module.exports = __webpack_public_path__ + "img/01.d4bd5a2d.jpg";